import apiClient from "./apiClient";
import {
    KdgLmsSystemNotificationDto,
    KdgLmsSystemNotificationMessageDto,
    KdgLmsSystemNotificationMessageRequestDto,
    KdgLmsSystemNotificationRequestDto,
    KdgNotificationSearchParam
} from "@/types/report";
import {PageResponse} from "@/types/pageResponse";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_NOTIFICATION = `${BASE_URL}/api/v1/notification`;
const FIND_ALL = `${BASE_URL_NOTIFICATION}/all`;
const FIND_BY_LMS_ID = `${BASE_URL_NOTIFICATION}/findByLmsId`;
const START_NOTIFICATION = `${BASE_URL_NOTIFICATION}/startMessage`;
const GET_ALL_MESSAGE = `${BASE_URL_NOTIFICATION}/getMessages`;
const SEND_MESSAGE = `${BASE_URL_NOTIFICATION}/sendMessage`;


export async function findAllLmsSystemNotification(params: KdgNotificationSearchParam): Promise<PageResponse<KdgLmsSystemNotificationDto>> {
    try {
        const response = await apiClient.post<PageResponse<KdgLmsSystemNotificationDto>>(`${FIND_ALL}`, params);
        return response.data;
    } catch (error) {
        console.error("Error getting Notification findAll:", error);
        throw error;
    }
}
export async function getGenerateAndExportListAsXLSX(
    params: KdgNotificationSearchParam
) {
    try {
        const response = await apiClient.post(
            `${BASE_URL_NOTIFICATION}/generate/list/xlsx`, params, {
                responseType: 'blob',
            }
        );
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = `tmp.xlsx`;

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    } catch (error) {
        console.error("Error generating 1c report:", error);
        throw error;
    }
}

export async function findByIdLmsSystemNotification(id: number | null | undefined): Promise<KdgLmsSystemNotificationDto> {
    try {
        const response = await apiClient.get<KdgLmsSystemNotificationDto>(`${FIND_BY_LMS_ID}/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error getting Notification findAll:", error);
        throw error;
    }
}

export async function startLmsSystemNotificationMessage(requestDto: KdgLmsSystemNotificationRequestDto): Promise<boolean> {
    try {
        const response = await apiClient.post<boolean>(START_NOTIFICATION, requestDto);
        return response.data;
    } catch (error) {
        console.log("error on getting pre calculation list", error);
        throw error;
    }
}
export async function getLmsSystemNotificationMessages(kdgNotificationId: string | null | undefined, params: KdgNotificationSearchParam, isClient: boolean): Promise<PageResponse<KdgLmsSystemNotificationMessageDto>> {
    try {
        var urlParam = isClient?'4Client': '4Admin';
        const response = await apiClient
            .post<PageResponse<KdgLmsSystemNotificationMessageDto>>(`${GET_ALL_MESSAGE}${urlParam}/${kdgNotificationId}`, params);
        return response.data;
    } catch (error) {
        console.log("error on getting message list", error);
        throw error;
    }
}

export async function sendLmsSystemNotificationMessage(requestDto: KdgLmsSystemNotificationMessageRequestDto): Promise<boolean> {
    try {
        const response = await apiClient.post<boolean>(SEND_MESSAGE, requestDto);
        return response.data;
    } catch (error) {
        console.log("error on getting pre calculation list", error);
        throw error;
    }
}

export async function sendLmsSystemNotificationMessageWithFiles(formData: any): Promise<any> {
    try {
        const response = await apiClient.post<any>(
            `${SEND_MESSAGE}/withFiles`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error save send message with files", error);
        throw error;
    }
}
